import { FileText, Download, X } from 'lucide-react';
import { useState } from 'react';

interface ExportModeProps {
  selectedCount: number;
  onCancel: () => void;
  onExportAsIs: () => Promise<void>;
  onGenerateContent: () => Promise<void>;
}

export const ExportMode = ({ selectedCount, onCancel, onExportAsIs, onGenerateContent }: ExportModeProps) => {
  const [isExportingAsIs, setIsExportingAsIs] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);

  const handleExportAsIs = async () => {
    setIsExportingAsIs(true);
    try {
      await onExportAsIs();
    } finally {
      setIsExportingAsIs(false);
    }
  };

  const handleGenerate = async () => {
    setIsGenerating(true);
    try {
      await onGenerateContent();
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="px-6 py-4 border-t border-gray-200 bg-white flex justify-between items-center">
      <span className="text-sm text-gray-600">
        {selectedCount > 0 ? `Selected ${selectedCount} conversation${selectedCount > 1 ? 's' : ''}` : 'Select conversations to export'}
      </span>
      <div className="flex gap-2">
        <button
          onClick={onCancel}
          className="px-3 py-1.5 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          Cancel
        </button>
        <button
          onClick={handleExportAsIs}
          disabled={selectedCount === 0 || isExportingAsIs}
          className="px-3 py-1.5 text-sm font-medium text-[#4c3794] border border-[#4c3794] rounded-lg hover:bg-purple-50 transition-colors disabled:opacity-30 disabled:cursor-not-allowed flex items-center gap-1.5"
        >
          {isExportingAsIs ? (
            <>
              <div className="w-4 h-4 border-2 border-[#4c3794] border-t-transparent rounded-full animate-spin" />
              <span>Exporting...</span>
            </>
          ) : (
            <>
              <FileText className="w-4 h-4" />
              <span>Export As-Is</span>
            </>
          )}
        </button>
        <button
          onClick={handleGenerate}
          disabled={selectedCount === 0 || isGenerating}
          className="px-3 py-1.5 text-sm font-medium text-white bg-[#4c3794] hover:bg-[#3a2a73] rounded-lg transition-colors disabled:opacity-30 disabled:cursor-not-allowed flex items-center gap-1.5"
        >
          {isGenerating ? (
            <>
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
              <span>Generating...</span>
            </>
          ) : (
            <>
              <Download className="w-4 h-4" />
              <span>Generate Content</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};
